import { LookupKeys } from 'ag-common-lib/lib/models/crm/lookup.model';

export enum ButtonType {
  normal = 'normal',
  default = 'default',
  success = 'success',
  danger = 'danger',
}

export const ButtonTypeMap = new Map([
  [ButtonType.normal, 'Normal'],
  [ButtonType.default, 'Default'],
  [ButtonType.success, 'Success'],
  [ButtonType.danger, 'Danger'],
]);

export const BUTTON_TYPE_LOOKUP = [ButtonType.normal, ButtonType.default, ButtonType.success, ButtonType.danger].map(
  value => {
    return { [LookupKeys.value]: value, [LookupKeys.description]: ButtonTypeMap.get(value) };
  },
);
